import { render, staticRenderFns } from "./LandlordProfileSettings.vue?vue&type=template&id=e5f36f5a&"
import script from "./LandlordProfileSettings.vue?vue&type=script&lang=js&"
export * from "./LandlordProfileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports